import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=a9dac33e"
import script from "./Index1.vue?vue&type=script&lang=js"
export * from "./Index1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports